import _ from 'lodash';
import { createSelectorCreator, defaultMemoize } from 'reselect';

/**
 * Create a "selector creator" that uses lodash.isEqual instead of === as the returned value for manualInputsSelector/inputsSelector
 * As they don't return a calculated values (it returns an object), so on each render equality check (=== by default) will fail
 */
const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  _.isEqual
);

const calculatorValidations = (state) => state.validations;

export const validationsSelector = createDeepEqualSelector(
  calculatorValidations,
  (validations) => {
    // omit `valid` key, we will search for the input name inside otherValidations
    const { valid, ...otherValidations } = validations;

    return otherValidations;
  }
);
